<template>
    <div class="breadcrumb flex items-center justify-left" v-if="list.length">
        <div v-if="list[0].back" @click="$router.go(-1)" class="back mr-[8] flex items-center justify-center"><i
                class="icon">&#xe6cd;</i></div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(item, index) in list" :key="item.name">
                <span class="front " :class="{ 'cursor-pointer': item.path }" @click="handleRouter(item)">{{ item.name
                    }}</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
export default {
    name: "breadcrumb",
    props: {
        breadcrumbList: {
            type: Array,
            default: () => { return [] },
        }
    },
    data() {
        return {
            list: []
        }
    },
    watch: {
        breadcrumbList: {
            handler(val) {
                this.list = val
            },
            immediate: true
        },
    },
    created() {
    },
    methods: {
        handleRouter(item) {
            let query = JSON.parse(window.localStorage.getItem('routerQuery'))
            if (item.path) {
                this.$router.push({ path: item.path, query: query[item.path] })
            }
        }
    },
}
</script>
<style scoped lang="less">
// @import '~@/assets/css/var.less';
.breadcrumb {
    background-color: #fff;
    padding: 10px 16px;
    // margin-bottom: 16px;
    display: flex;

    .no-path {
        color: #303133;
        cursor: default;
        line-height: 20px !important;
    }

    .path {
        color: #303133;
        cursor: pointer;
        line-height: 20px !important;
    }

    .last {
        color: #909399;
    }

    .message {
        color: #c4c0cc;
    }

    .back {
        height: 20px;
        width: 20px;
        text-align: center;
        // line-height: 20px;
        font-size: 12px;
        color: #303133;
        border: 1px solid #C3CAD9;
        border-radius: 2px;

        i {
            zoom: 0.8;
        }
    }

    /deep/ .el-breadcrumb {
        font-size: 12px;
        line-height: 20px !important;

        .el-breadcrumb__inner {
            color: #606266 !important;
        }

        .el-breadcrumb__item:last-child .el-breadcrumb__inner {
            color: #000000 !important;
        }
    }

    // /deep/ .el-breadcrumb__separator {
    //     color: #303133 !important;
    //     font-weight: 100 !important;
    // }

    // /deep/ .el-breadcrumb__inner {
    //     color: #303133 !important;
    // }
}
</style>